(function () {
  if (window.__sipitHeaderInit) return;
  window.__sipitHeaderInit = true;

  const burger = document.querySelector('[data-sipit-burger]');
  const mnav = document.querySelector('[data-sipit-mnav]');
  const closeBtn = document.querySelector('[data-sipit-mnav-close]');

  if (burger && mnav) {
    const open = () => {
      mnav.classList.add('open');
      mnav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const shut = () => {
      mnav.classList.remove('open');
      mnav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    burger.addEventListener('click', open);
    closeBtn?.addEventListener('click', shut);
    mnav.querySelectorAll('a').forEach((link) => link.addEventListener('click', shut));
  }

  const bubble = document.querySelector('[data-sipit-cart-count]');
  if (bubble) {
    const renderCount = (count) => {
      bubble.textContent = count;
      bubble.hidden = count < 1;
    };

    document.addEventListener('shopify:cart-lines-update', (event) => {
      event.detail?.promise?.then(({ cart, detail }) => {
        renderCount(cart?.totalQuantity ?? detail?.itemCount ?? 0);
      });
    });
  }
})();

/* boot-session-v6 — show every browser session until signup */
(function () {
  if (window.__sipitLaunchPopupBoot) return;
  window.__sipitLaunchPopupBoot = true;
  if (!document.body || !document.body.classList.contains('template-index')) return;

  var SUBSCRIBED_KEY = 'sipit_launch_subscribed';
  var SESSION_KEY = 'sipit_launch_session_dismiss';
  var DELAY_MS = 3000;

  function forceShow() {
    try {
      return new URLSearchParams(window.location.search).get('launch_popup') === '1';
    } catch (e) {
      return false;
    }
  }

  function clearLegacy() {
    try {
      [
        'sipit_launch_popup_v1',
        'sipit_launch_popup_v2',
        'sipit_launch_popup_v3',
        'sipit_launch_popup_v4',
        'sipit_launch_popup_v5',
      ].forEach(function (k) {
        localStorage.removeItem(k);
      });
    } catch (e) {}
  }

  function isSubscribed() {
    if (forceShow()) return false;
    try {
      return localStorage.getItem(SUBSCRIBED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSubscribed() {
    if (forceShow()) return;
    try {
      localStorage.setItem(SUBSCRIBED_KEY, '1');
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  }

  function isDismissedSession() {
    if (forceShow()) return false;
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markDismissedSession() {
    if (forceShow()) return;
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  function ensureMarkup() {
    var existing = document.getElementById('SipitLaunchPopupLayout');
    if (existing) return existing;

    document.querySelectorAll('[data-sipit-launch-popup]').forEach(function (node) {
      if (node.id !== 'SipitLaunchPopupLayout') node.remove();
    });

    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<div class="sipit-shell sipit-launch-popup" id="SipitLaunchPopupLayout" data-sipit-launch-popup data-delay="' +
      DELAY_MS +
      '" data-sipit-popup-build="session-v6" hidden>' +
      '<div class="sipit-launch-popup__backdrop" data-sipit-launch-dismiss tabindex="-1"></div>' +
      '<div class="sipit-launch-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="SipitLaunchPopupLayout-title" aria-describedby="SipitLaunchPopupLayout-body">' +
      '<button type="button" class="sipit-launch-popup__close" data-sipit-launch-dismiss aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
      '<div class="sipit-launch-popup__accent" aria-hidden="true"></div>' +
      '<form method="post" action="/contact#SipitLaunchFormLayout" id="SipitLaunchFormLayout" accept-charset="UTF-8" class="sipit-launch-popup__form">' +
      '<input type="hidden" name="form_type" value="customer" />' +
      '<input type="hidden" name="utf8" value="✓" />' +
      '<input type="hidden" name="contact[tags]" value="launch-waitlist,newsletter">' +
      '<input type="hidden" name="contact[accepts_marketing]" value="true">' +
      '<input type="hidden" name="contact[note]" value="" data-sipit-launch-note>' +
      '<p class="sipit-launch-popup__eyebrow">Coming soon</p>' +
      '<h2 id="SipitLaunchPopupLayout-title">Get 10% off</h2>' +
      '<p id="SipitLaunchPopupLayout-body" class="sipit-launch-popup__text">Drop your email — get 10% off. Phone is optional. Join the list for launches, tips and subscriber-only offers.</p>' +
      '<div class="sipit-launch-popup__fields">' +
      '<label class="sipit-launch-popup__label" for="SipitLaunchPopupLayout-email">Email</label>' +
      '<input id="SipitLaunchPopupLayout-email" class="sipit-launch-popup__input" type="email" name="contact[email]" placeholder="you@email.com" required autocomplete="email">' +
      '<label class="sipit-launch-popup__label" for="SipitLaunchPopupLayout-phone">Phone (optional)</label>' +
      '<input id="SipitLaunchPopupLayout-phone" class="sipit-launch-popup__input" type="tel" name="contact[phone]" placeholder="(555) 123-4567" autocomplete="tel" inputmode="tel" data-sipit-launch-phone>' +
      '</div>' +
      '<button type="submit" class="sipit-launch-popup__submit">Notify me</button>' +
      '<p class="sipit-launch-popup__privacy">We\'ll only use this to tell you when we launch. No spam.</p>' +
      '</form></div></div>';

    var root = wrap.firstElementChild;
    document.body.appendChild(root);
    return root;
  }

  function bind(root) {
    if (!root || root.dataset.sipitLaunchReady === '1') return;
    root.dataset.sipitLaunchReady = '1';
    clearLegacy();

    var dialog = root.querySelector('.sipit-launch-popup__dialog');
    var form = root.querySelector('form');
    var phoneInput = root.querySelector('[data-sipit-launch-phone]');
    var noteInput = root.querySelector('[data-sipit-launch-note]');
    var successEl = root.querySelector('[data-sipit-launch-success]');
    var lastFocus = null;

    function getFocusable() {
      if (!dialog) return [];
      return Array.prototype.slice.call(
        dialog.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
    }

    function openPopup() {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('sipit-launch-popup-open');
      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
        var focusables = getFocusable();
        if (focusables.length) {
          try {
            focusables[0].focus();
          } catch (e) {}
        }
      });
    }

    function closePopup(opts) {
      opts = opts || {};
      root.classList.remove('is-open');
      document.documentElement.classList.remove('sipit-launch-popup-open');
      root.hidden = true;
      if (opts.subscribe) markSubscribed();
      else markDismissedSession();
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus();
        } catch (e) {}
      }
    }

    root.querySelectorAll('[data-sipit-launch-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup({ subscribe: !!(successEl && el.closest('[data-sipit-launch-success]')) });
      });
    });

    document.addEventListener('keydown', function (event) {
      if (root.hidden || !root.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup({});
      }
    });

    if (form && phoneInput && noteInput) {
      form.addEventListener('submit', function () {
        var phone = (phoneInput.value || '').trim();
        noteInput.value = phone ? 'Launch waitlist SMS: ' + phone : 'Launch waitlist signup';
      });
    }

    if (successEl) {
      markSubscribed();
      openPopup();
      return;
    }

    if (isSubscribed() || isDismissedSession()) return;

    var delay = parseInt(root.getAttribute('data-delay') || String(DELAY_MS), 10);
    if (isNaN(delay) || delay < 0) delay = DELAY_MS;
    window.setTimeout(openPopup, forceShow() ? 0 : delay);
  }

  function boot() {
    clearLegacy();
    if (isSubscribed() && !forceShow()) return;
    bind(ensureMarkup());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* stamp session-v6-1784049500 */


(function ensureSipitFavicon(){
  try {
    if (document.querySelector('link[data-sipit-favicon]')) return;
    var href = document.querySelector('.sipit-header .brand img, .sipit-footer .foot-brand img');
    // Prefer theme asset path parallel to logo
    var logo = document.querySelector('.sipit-header .brand img');
    var fav = (logo && logo.src) ? logo.src.replace(/sipit-logo\.png.*/, 'sipit-favicon.png') : null;
    if (!fav || fav.indexOf('sipit-favicon.png') === -1) {
      fav = (window.Shopify && Shopify.cdnHost)
        ? ('https://' + Shopify.cdnHost + '/shop/files/sipit-favicon.png')
        : '/cdn/shop/t/16/assets/sipit-favicon.png';
    }
    var link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = fav;
    link.setAttribute('data-sipit-favicon', '1');
    document.head.appendChild(link);
    var apple = document.createElement('link');
    apple.rel = 'apple-touch-icon';
    apple.href = fav.replace('sipit-favicon.png', 'sipit-favicon-180.png');
    apple.setAttribute('data-sipit-favicon', '1');
    document.head.appendChild(apple);
  } catch (e) {}
})();


/* favicon-boot-1784865023 */
